module.exports = __webpack_public_path__ + "img/princess.8bc2f9d4.png";